<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<div #dropdown='ngbDropdown' class="chip-selector-zone-dropdown-wrapper" ngbDropdown>
  @if (state.isEditMode) {
    @if (!hasUserInput) {
      <div class="chip-selector-zone-dropdown-toggle" data-cy="chip-selector-zone-dropdown-toggle"
        ngbDropdownToggle>
        <span class="chip-selector-zone-dropdown-text">
          <span class="chip-selector-zone-dropdown-text-placeholder"
            data-cy="select-in-table-toggle-placeholder">{{showDropdownOption()}}
          </span>
        </span>
        <span class="chip-selector-zone-dropdown-toggle-arrow {{arrowClass(dropdown.isOpen())}}"
          data-cy="chip-selector-zone-dropdown-toggle-arrow">
        </span>
      </div>
    }
    @if (hasUserInput) {
      <app-input-dropdown
        (inputValueChange)="selectOption($event)"
        [inputFormatter]="inputFormatter"
        [resultFormatter]="inputFormatter"
        [resultsFunction]="searchFunction"
        baseCypressTag="users-table-supplier-filter"
        class="filter-button"
        placeholder="Select a supplier">
      </app-input-dropdown>
    }
  }

  @if (!state.isEditMode) {
    <div
      class="chip-selector-zone-selected-value">
      <app-tooltip [dynamic]="isTooltipDynamic" [message]="itemTooltip">
        <span data-cy="chip-selector-zone-dropdown-value">{{itemTitle}}</span>
      </app-tooltip>
    </div>
  }

  <div class="options" data-cy="chip-selector-zone-dropdown" ngbDropdownMenu>
    @for (child of options; track child) {
      <app-chip-selector-zone-dropdown-option
        (selectedOption)="selectOption($event)"
      [option]="child"></app-chip-selector-zone-dropdown-option>
    }
  </div>
</div>


<ng-template #tooltipTemplate>
  <ng-container *ngTemplateOutlet="state.selectOptionValue.tooltip; context: state.selectOptionValue.value"></ng-container>
</ng-template>
